"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccessPointWithinUserRoleScope = isAccessPointWithinUserRoleScope;
var hasura_1 = require("../hasura");
function isAccessPointWithinUserRoleScope(accessPoint, userRole) {
    var accessPointId = accessPoint.accessPointId, property = accessPoint.property;
    var role = userRole.role, scopedOrganizationId = userRole.scopedOrganizationId, scopedPropertyId = userRole.scopedPropertyId, scopedUnit = userRole.scopedUnit, scopedAccessPointId = userRole.scopedAccessPointId;
    switch (role.permissionScope) {
        case hasura_1.PermissionScope_enum.GLOBAL:
            return true;
        case hasura_1.PermissionScope_enum.ORGANIZATION:
            return scopedOrganizationId === property.organizationId;
        case hasura_1.PermissionScope_enum.PROPERTY:
            return scopedPropertyId === property.propertyId;
        case hasura_1.PermissionScope_enum.UNIT:
            return (scopedUnit === null || scopedUnit === void 0 ? void 0 : scopedUnit.propertyId) === property.propertyId;
        case hasura_1.PermissionScope_enum.ACCESS_POINT:
            return scopedAccessPointId === accessPointId;
        default:
            return false;
    }
}
//# sourceMappingURL=isAccessPointWithinUserRoleScope.js.map